import {html, css, LitElement, ref, createRef, svg } from 'lit'



const resetIcon = svg`
<svg width="16" height="16" viewBox="0 0 16 16" fill="none" xmlns="http://www.w3.org/2000/svg">
<path d="M1.93366 15.5834L0.416992 14.0667L6.48366 8.00008L0.416992 1.93341L1.93366 0.416748L8.00033 6.48341L14.067 0.416748L15.5837 1.93341L9.51699 8.00008L15.5837 14.0667L14.067 15.5834L8.00033 9.51675L1.93366 15.5834Z" fill="#1C1B1F"/>
</svg>
`

const searchIcon = svg`
<svg width="19" height="19" viewBox="0 0 19 19" fill="none" xmlns="http://www.w3.org/2000/svg">
<path d="M17.4799 18.8965L11.1799 12.5965C10.6799 12.9965 10.1049 13.3132 9.45488 13.5465C8.80488 13.7798 8.11322 13.8965 7.37988 13.8965C5.56322 13.8965 4.02572 13.2673 2.76738 12.009C1.50905 10.7507 0.879883 9.21315 0.879883 7.39648C0.879883 5.57982 1.50905 4.04232 2.76738 2.78398C4.02572 1.52565 5.56322 0.896484 7.37988 0.896484C9.19655 0.896484 10.734 1.52565 11.9924 2.78398C13.2507 4.04232 13.8799 5.57982 13.8799 7.39648C13.8799 8.12982 13.7632 8.82148 13.5299 9.47148C13.2966 10.1215 12.9799 10.6965 12.5799 11.1965L18.8799 17.4965L17.4799 18.8965ZM7.37988 11.8965C8.62988 11.8965 9.69238 11.459 10.5674 10.584C11.4424 9.70898 11.8799 8.64648 11.8799 7.39648C11.8799 6.14648 11.4424 5.08398 10.5674 4.20898C9.69238 3.33398 8.62988 2.89648 7.37988 2.89648C6.12988 2.89648 5.06738 3.33398 4.19238 4.20898C3.31738 5.08398 2.87988 6.14648 2.87988 7.39648C2.87988 8.64648 3.31738 9.70898 4.19238 10.584C5.06738 11.459 6.12988 11.8965 7.37988 11.8965Z" fill="#1C1B1F"/>
</svg>
`


const backIcon = svg`
<svg width="18" height="18" viewBox="0 0 18 18" fill="none" xmlns="http://www.w3.org/2000/svg">
<path d="M4.47676 10.0833L10.5434 16.1499L8.99967 17.6666L0.333008 8.99992L8.99967 0.333252L10.5434 1.84992L4.47676 7.91659H17.6663V10.0833H4.47676Z" fill="#1C1B1F"/>
</svg>
`


export class MobileClientDropdown extends LitElement {
    $searchfield = createRef()
    $dropdown = createRef()

    static get properties() {
        return {
            values: {type: Object, state: true}
        }
    }

    connectedCallback() {
        super.connectedCallback()
        this.current  = this.current || this.values[0]["ID"]
    }
    
    render() {
        if (this.values) {
            let items = []
            
            for (let item of this.values) {
                let name = `${item["LAST_NAME"]} ${item["NAME"]}`
                if (name.trim().length) {
                    items.push(html`<div class="item" @click=${() => this.select(item)}>
                        <div class="item-id">${item["ID"]}</div>
                        <div class="name">${name}</div> 
                    </div>`)
                }
            }            

            return html`
                <div class="searchbar">
                    <input type="text" ${ref(this.$searchfield)} @input=${this.search}>
                    <button @click=${this.resetInput}>${this.$searchfield.value && this.$searchfield.value.value.trim().length ? resetIcon : searchIcon}</button>
                </div>
                <div class="items">${items}</div>
            `
        }
    }

    search() {
        if (this.$searchfield.value.value) {
            this.dispatchEvent(new CustomEvent("search", {detail: this.$searchfield.value.value, composed: true}))
        } else {
            this.resetInput()
        }
    }


    resetInput() {
        this.dispatchEvent(new CustomEvent("search.reset", {composed: true}))
        this.$searchfield.value.value = ""
        this.found = []
        this.requestUpdate()
    }

    addGlobalListener() {
        document.body.addEventListener("click", evt => {
            if (evt.detail != this) {
                this.$dropdown.value && (this.$dropdown.value.style.display = `none`)
            } else {
                this.addGlobalListener()
            }
        }, {once: true})
    }

    select(item) {
        this.dispatchEvent(new CustomEvent("select", {composed: true, detail: item}))
        this.requestUpdate()
    }

    static get styles() {
        return css`
            :host {
                display: flex;
                flex-direction: column;
                position: relative;
                height: 100%;
                overflow-y: hidden;
            }

            .items {
                display: flex;
                flex-direction: column;
                overflow-y: auto;
                gap: 15px;
            }

            .item {
                font-family: "Roboto Medium";
                display: grid;
                grid-template-columns: 50px 1fr;
                gap: 20px;
                cursor: pointer;
            }

            .item .item-id {
                color: #0004;
            }

            .users {
                display: flex;
                flex-direction: column;
                gap: 10px;
            }

            .readout {
                display: grid;
                grid-template-columns: 1fr 20px;
                gap: 10px;
            }

            button {
                appearance: none;
                border: none;
                background: none;
            }

            .dropdown {
                position: absolute;
                top: calc(100% + 10px);
                width: 100%;
                display: none;
                flex-direction: column; 
                box-sizing: border-box;
                background: white;
                border: 1px solid #D2D2D2;
                box-shadow: 0px 4px 8.4px rgba(0, 0, 0, 0.13);
                z-index: 2;
            }

            .dropdown > * {
                padding: 10px;
            }

            .dropdown > *:hover {
                background:rgba(0, 0, 0, 0.05)
            }

            .searchbar {
                display: flex;
                position: relative;
                margin-bottom: 15px;
            }

            .searchbar button {
                display: flex;
                justify-content: center;
                align-items: center;
                appearance: none;
                border: none;
                background: none;
                position: absolute;
                right: 5px;
                height: 100%;
            }

            .searchbar input {
                width: 100%;
                box-sizing: border-box;
                height: 30px;
                appearance: none;
                border: none;
                background: rgba(0, 0, 0, 0.03);
                border-radius: 8px;
                padding-left: 10px;
            }

            .searchbar input:focus {
                outline: none;
                box-shadow: inset 0px 4px 5px rgba(0, 0, 0, 0.1);
            }
        `
    }
}

customElements.define('mobile-client-dropdown', MobileClientDropdown);

const dropIcon = svg`
<svg width="12" height="7" viewBox="0 0 12 7" fill="none" xmlns="http://www.w3.org/2000/svg">
<path d="M0.525391 0.841797L5.96094 6.27734L11.3965 0.841797H0.525391Z" fill="black"/>
</svg>
`


export class ClientDropdown extends LitElement {
    
    static get properties() {
        return {
            value: {type: String, reflect: true}
        }
    }

    $dropdown = createRef()

    constructor(values) {
        super()
        this.values = values
        this.value  = values[0].id
    }
    
    render() {
        let top = null
        let others = []

        for (const item of this.values) {
            if (item.id == this.value) {
                top = html`<div class="top" @click=${this.dropdown}>${item.value}</div>`
            } 
            others.push(html`<div class="other" @click=${() => this.select(item.id)}>${item.value}</div>`)
        }

        return html`
            <div class="readout" part="readout" @click=${this.dropdown} >
                ${top}
                <button>${dropIcon}</button>
            </div>
            <div class="dropdown" part="dropdown" ${ref(this.$dropdown)}>
                ${others}
            </div>
        `
    }

    dropdown(evt) {
        this.$dropdown.value.style.display = `flex`
        document.body.addEventListener("click", () => {
            this.$dropdown.value.style.display = `none`
        }, {once: true})
        evt.stopPropagation()
    }

    select(id) {
        this.value = id
        this.$dropdown.value.style.display = `none`
        this.requestUpdate()
    }

    static get styles() {
        return css`
            :host {
                position: relative;
            }

            .readout {
                display: grid;
                grid-template-columns: 1fr 20px;
                gap: 10px;
                width: 100%;
                height: 100%;
                align-items: center;
            }

            button {
                appearance: none;
                border: none;
                background: none;
            }

            .dropdown {
                position: absolute;
                top: calc(100% + 10px);
                width: 100%;
                display: none;
                flex-direction: column; 
                box-sizing: border-box;
                background: white;
                border: 1px solid #D2D2D2;
                box-shadow: 0px 4px 8.4px rgba(0, 0, 0, 0.13);
            }

            .dropdown > * {
                padding: 10px;
            }

            .dropdown > *:hover {
                background:rgba(0, 0, 0, 0.05)
            }
        `
    }
}

customElements.define('client-dropdown', ClientDropdown);